<template>
  <div>
    <excise-transactions listObject="spirit" :objectId="spiritId"
                          :back="[{text:'Spirits',to:{name:'Spirits'}}]"
                          :contents="false" vessel :exciseTypes="excise.spiritsExciseTypes(true)"/>
  </div>
</template>

<script>
import ExciseTransactions from '@/components/ExciseTransactions'
import excise from '@/plugins/excise'

export default {
  name: 'SpiritsTransactions',
  components: {ExciseTransactions},
  props: {
    spiritId: {type:String, required:true}
  },
  data() {
    return {
      excise
    }
  }
}
</script>